export type PrometheusPostgreSqlInsertStatsBackendApiProps = {
    created: number;
    pg_stat_database_tup_inserted: number;
};

export default class PrometheusPostgreSqlInsertStats {
    readonly created: number;
    readonly pgStatDatabaseTupInserted: number;

    constructor(props: PrometheusPostgreSqlInsertStatsBackendApiProps) {
        this.created = props.created;
        this.pgStatDatabaseTupInserted = props.pg_stat_database_tup_inserted;
    }
}
